// Converts military time passed in as a raw number to a displable time format

export function convertTime (time: string, showAmPM?: boolean) {
    const tempTime = ZeroPad(time);
    const hours = parseInt(tempTime.slice(0, 2), 10);
    const minutes = tempTime.slice(2);
    const amPMFlag = showAmPM === undefined ? true : showAmPM;
    let displayTime = '';
    if (amPMFlag) {
        if (hours < 12) {
            displayTime = minutes === '00' ? hours + 'AM' : hours + ':' + minutes + 'AM';
        } else if (hours === 12) {
            displayTime = minutes === '00' ? hours + 'PM' : hours + ':' + minutes + 'PM';
        } else {
            const displayHours = hours - 12;
            displayTime = minutes === '00' ? displayHours + 'PM' : displayHours + ':' + minutes + 'PM';
        }
    } else {
        displayTime = hours + ':' + minutes;
    }

    return displayTime;
}

export function convertTo24(time: string) {
    // Times are sent in in the HH:MMxx format, where xx is am or pm
    const amPMFlag = time.slice(5);
    let hours = parseInt(time.slice(0, 2), 10);
    const minutes = time.slice(3, 5);
    if ((amPMFlag === 'pm' || amPMFlag === 'PM') && (hours < 12)) {
        hours += 12;
    }

    return parseInt((hours + minutes), 10);
}

function ZeroPad (number: string) {
    const z = '0';
    const rtnNumber = number + '';

    return rtnNumber.length > 3 ? rtnNumber : new Array(4 - rtnNumber.length + 1).join(z) + rtnNumber;
}

export function convertTimeZeros (time: string, showAmPM?: boolean, zeroHr?: boolean) {
    const tempTime = ZeroPad(time);
    const hours = parseInt(tempTime.slice(0, 2), 10);
    const minutes = tempTime.slice(2);
    const amPMFlag = showAmPM === undefined ? true : showAmPM;
    let displayTime = '';
    if (amPMFlag) {
        if (hours < 12) {
            const displayNumHours = hours;
            let displayHours = displayNumHours.toString();
            if (zeroHr) {
                if (displayHours.length === 1) {
                    displayHours = '0' + displayHours;
                }
            }
            displayTime = minutes === '00' ? displayHours + ':' + minutes + 'AM' : displayHours + ':' + minutes + 'AM';
        } else if (hours === 12) {
            const displayNumHours = hours;
            let displayHours = displayNumHours.toString();
            if (zeroHr) {
                if (displayHours.length === 1) {
                    displayHours = '0' + displayHours;
                }
            }
            displayTime = minutes === '00' ? displayHours + ':' + minutes + 'PM' : displayHours + ':' + minutes + 'PM';
        } else {
            const displayNumHours = hours - 12;
            let displayHours = displayNumHours.toString();
            if (zeroHr) {
                if (displayHours.length === 1) {
                    displayHours = '0' + displayHours;
                }
            }
            displayTime = minutes === '00' ? displayHours + ':' + minutes + 'PM' :
                displayHours + ':' + minutes + 'PM';
        }
    } else {
        const displayNumHours = hours;
        let displayHours = displayNumHours.toString();
        if (zeroHr) {
            if (displayHours.length === 1) {
                displayHours = '0' + displayHours;
            }
        }
        displayTime = displayHours + ':' + minutes;
    }

    return displayTime;
}